import { render } from "./AEIncidenceTable.vue?vue&type=template&id=1895dfd6"
import script from "./AEIncidenceTable.js?vue&type=script&lang=js"
export * from "./AEIncidenceTable.js?vue&type=script&lang=js"

import "./AEIncidenceTable.vue?vue&type=style&index=0&id=1895dfd6&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__